import styles from "./index.module.scss";
import { Avatar, Dropdown, Image, message, Pagination, Spin } from "antd";
import SizeBox from "@/components/SizeBox";
import { useSelector } from "react-redux";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  APIAddFavoriteItems, APICapInvitation,
  APIDeleteFavoriteItems,
  APIErrorFetch,
  APIGetAnyStarrGMV,
  APIGetCheckV2Permissions,
  APIGetCommisson,
  APIGetCommissonList,
  APIGetLikeProductList,
  APIGetLinkByPid,
  APIGetMyShowCase,
  APIGetRecommendList,
  APIGetUserGMV, APIGetUserInfo, APIRefreshCapStatus
} from "@/api";
import dynamic from 'next/dynamic';
import {
  addTagIcon,
  anay_icon,
  anlay_top_icon_1,
  anlay_top_icon_2,
  anlay_top_icon_3,
  anlay_top_icon_4,
  avgComRateIcon,
  avgEcCommentIcon,
  avgEcLiveLikeIcon,
  avgEcVideoShareIcon,
  avgEcVLikeIcon,
  avgLiveViewIcon,
  BioIcon,
  brandCountIcon,
  CategoryIcon,
  CheckedIcon,
  CreateLinkLoadingGIF,
  ecAvgVideoCommentIcon,
  ecLiveShareIcon,
  ecomVideoIcon,
  editTagIcon,
  eLiveIcon,
  GmvIcon,
  Info1Icon,
  Info2Icon,
  Info3Icon,
  InfoIcon3,
  InfoIcon4,
  LikeIcon,
  liveGmvIcon,
  LocationIcon,
  NoLikeIcon,
  primary_down_icon,
  ShowcaseIcon,
  SoldIcon,
  StatusIcon,
  TableNext,
  TablePre,
  VideoGmvIcon
} from "@/config/config";
import CustomEmpty from "@/components/CustomEmpty";
import CommonLoading from "@/components/CommonLoading";
import LogoutModal from "@/components/LogoutModal";
import { useRouter } from "next/router";
import CommonPopover from "@/components/CommonPopover";
import CommonQuestionPop from "@/components/CommonQuestionPop";
import AuthorizationModal from "@/components/AuthorizationModal";
import { CommonNormalBtn, CommonPrimaryBtn } from "@/components/CommonBtn";
import Link from "next/link";
import ReactECharts from 'echarts-for-react';
import CancelAuthModal from "@/components/CancelAuthModal";
import {getProductImage, getProductImages} from "@/utils/utils";
import AddShowCaseStepModal from "@/components/ProductModal";
import { DownOutlined, LoadingOutlined } from "@ant-design/icons";
import EligibleModal, { Eligible7DTipsModal } from "@/components/EligibleModal";
import { Collapse } from 'antd';
import gaTracker from "@/ga";
import useDispatchAction from "@/hooks/useDisptachAction";
import { setUserInfo } from "@/redux/actions/home";
import AppImage from "@/components/AppImage";
import { formatKMBNumber } from "@/utils/numUtils";
import UnLockHighestCommissionModal from "@/components/UnLockHighestCommissionModal";
import ProductCard from "@/components/ProductCard";
import { GetFreeSampleModal } from "@/components/GetFreeSampleModal";
import Masonry from "react-masonry-css";
import GridDistortion from "@/components/Animation/GridDistortion";
import CategorySelectModal from "@/components/CategorySelectModal";
import useLanguage from "@/hooks/useLanguage";
import useErrorMap from "@/hooks/useErrorMap";

const CreateLinkModal = dynamic(() => import('@/components/CreateLinkModal'), {
  ssr: false,  // Disable SSR for this component
});


const needAuthKey = [2, 5];

const tabKeyEventMap = {
  1: "profile",
  2: "showcase",
  3: "collection",
  5: "analysls"
};

export const lightTips = (tips) => {
  return <span className={"high_light mx-1 font-bold"}>{tips}</span>;
};

const PersonCenter = () => {
  const userInfo = useSelector(state => state.home.userInfo.userInfo);
  const [logoutModal, setLogoutModal] = useState(false);
  const [eligibleModal, setEligibleModal] = useState(false);
  const [eligibleModal7Day, setEligibleModal7Day] = useState(false);
  const [currentTabKey, setCurrentTabKey] = useState(3);
  const currentTabRef = useRef(3);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [isObtain, setIsObtain] = useState(false);
  const [userPermissions, setUserPermissions] = useState(-1); // -1:等待接口返回， 1:已经授权  0:未授权
  const router = useRouter();
  const { tabKey, subKey } = router.query;

  const [containLoading, setContainLoading] = useState(false);
  const [obtainLoading, setObtainLoading] = useState(false);

  const [myShowcaseTabKey, setMyShowcaseTabKey] = useState(1);
  const [errorMsg, setErrorMsg] = useState("");

  const { t, isUS } = useLanguage();

  useEffect(() => {
    if (subKey) {
      setMyShowcaseTabKey(Number(subKey));
    }
  }, [subKey]);

  useEffect(() => {
    setIsObtain(userInfo?.obtain);
  }, [userInfo]);

  const tabList = useMemo(()=>{
    if (isUS) {
      return [
        {
          label: t('person_center.my_profile'),
          key: 1,
          icon: "/images/header/people-icon.svg",
          actIcon: "/images/header/people-icon-active.svg",
        },
        {
          label: t('person_center.my_collection'),
          key: 3,
          icon: "/images/header/collection-icon.svg",
          actIcon: "/images/header/collection-icon-active.svg",
        },
        {
          label: t('person_center.my_showcase'),
          key: 2,
          icon: "/images/header/showcase-icon.svg",
          actIcon: "/images/header/showcase-icon-active.svg",
        },
        {
          label: t('person_center.earnings_analysis'),
          key: 5,
          icon: "/images/header/earn-icon.svg",
          actIcon: "/images/header/earch-icon-active.svg",
        },
        {
          label: t('person_center.logout'),
          key: 4,
          icon: "/images/header/logout-icon.svg",
          actIcon: "/images/header/logout-icon-active.svg",
        },
      ];
    }
    return  [
      {
        label: t('person_center.my_profile'),
        key: 1,
        icon: "/images/header/people-icon.svg",
        actIcon: "/images/header/people-icon-active.svg",
      },
      {
        label: t('person_center.my_collection'),
        key: 3,
        icon: "/images/header/collection-icon.svg",
        actIcon: "/images/header/collection-icon-active.svg",
      }
    ];
  }, [isUS]);

  const render = () => {
    if (currentTabKey === 1) {
      return <MyProfile>

      </MyProfile>;
    }
    if (currentTabKey === 2) {
      return <MyShowCase tabKey={myShowcaseTabKey} setTabKey={setMyShowcaseTabKey}></MyShowCase>;
    }
    if (currentTabKey === 3) {
      return <MyCollection></MyCollection>;
    }

    if (currentTabKey === 5) {
      return <Analysls>

      </Analysls>;
    }
  };

  const onClickMenu = (key) => {
    if (key === 4) {
      setLogoutModal(true);
      return;
    }

    if (needAuthKey.includes(key) && userPermissions === 0) {
      setShowAuthModal(true);
      return;
    }

    currentTabRef.current = key;
    setCurrentTabKey(key);
  };

  useEffect(() => {
    if (tabKey) {
      onClickMenu(Number(tabKey));
      gaTracker.trackEvent(tabKeyEventMap[tabKey ?? 1] ?? "", true);
    }
  }, [tabKey]);

  useEffect(() => {
    checkPermission();
  }, []);

  const { errCodeMap } = useErrorMap();
  const checkPermission = () => {
    APIGetCheckV2Permissions().then(resp => {
      if (resp.data) {
        setUserPermissions(resp.data?.permissions ? 1 : 0);
        if (resp.data.permissions === false && needAuthKey.includes(currentTabRef.current)) {
          setShowAuthModal(true);
          setCurrentTabKey(3);
          currentTabRef.current = 3;
        }
      }
    });
  };

  const checkObtain = async () => {
    gaTracker.trackEvent("profile_obtain", true);
    try {
      setContainLoading(true);
      const res = await APICapInvitation({});
      setContainLoading(false);
      if (res?.data?.result.isSucess === true) {
        setEligibleModal(true);
        return;
      }

      if (res?.data?.result.isSucess === false) {
        setEligibleModal7Day(true);
        let error = errCodeMap[res.data.result.code] ??  t('unlock_commission_modal.unknown_error');
        setErrorMsg(error);
        return;
      }

    } catch (e) {
      console.log(e);
    }
    setContainLoading(false);
  };
  const dispatchAction = useDispatchAction({ setUserInfo });
  const getUserInfo = () => {
    const token = localStorage.getItem("token");
    if (token) {
      APIGetUserInfo().then(resp => {
        if (resp.data.user) {
          const user = resp.data.user;
          dispatchAction.setUserInfo(user);
          localStorage.setItem("user", JSON.stringify(user));
        }
      });
    }
  };

  const reFreshCap = async () => {
    gaTracker.trackEvent("profile_already", true);
    setObtainLoading(true);
    const res = await APIRefreshCapStatus({});
    setObtainLoading(false);
    setIsObtain(res.data.result);
    getUserInfo();
    if (!res.data.result) {
      setEligibleModal7Day(true);
      setErrorMsg(<div>
        Join our
        {lightTips(" Creator Affiliate Program ")} to enjoy the highest commission rate, click the
        {lightTips(" Obtain Eligibility ")} button to join us!
      </div>);
    }
  };

  return <div className={styles.person_center}>
    {/* <div className={styles.bg_wrap}></div>*/}

    <div className={styles.content_wrap}>
      <div className={styles.left_card}>
        <div className={"w-full flex flex-col gap-[20px]"}>
          {
            tabList.map(item => {
              return <TabItem icon={item.icon} activeIcon={item.actIcon} label={item.label} onClick={(key) => onClickMenu(key)} id={item.key} current={currentTabKey}></TabItem>;
            })
          }
        </div>
      </div>
      {render()}
    </div>
    <SizeBox h={100}></SizeBox>
    <EligibleModal show={eligibleModal} onCancel={() => setEligibleModal(false)}></EligibleModal>
    <Eligible7DTipsModal content={errorMsg} show={eligibleModal7Day} onCancel={() => setEligibleModal7Day(false)}></Eligible7DTipsModal>
    <LogoutModal show={logoutModal} onCancel={() => setLogoutModal(false)}></LogoutModal>
    <AuthorizationModal show={showAuthModal} onCancel={() => setShowAuthModal(false)}></AuthorizationModal>

  </div>;
};


const Analysls = () => {
  const [showCancelAuthModal, setShowCancelAuthModal] = useState(false);
  const [commissionDataTime, setCommissionDataTime] = useState(1);
  const [commissionDataLoading, setCommissionDataLoading] = useState(false);
  const [gmvDataTime, setGmvDataTime] = useState(1);
  const [resMap, setResMap] = useState({});
  const [anyStarrCommissionData, setAnyStarrCommissionData] = useState();
  const [anyStarrCommissionDataLoading, setAnyStarrCommissionDataLoading] = useState(false);
  const [gmvData, setGmvData] = useState();

  const getCommissionData = () => {
    setAnyStarrCommissionDataLoading(true);
    APIGetCommisson({ selectType: commissionDataTime }).then(resp => {
      if (resp.data.result) {
        setAnyStarrCommissionData(resp.data.result);
      }
    }).finally(() => {
      setAnyStarrCommissionDataLoading(false);
    });
  };

  const getGMVData = () => {
    setCommissionDataLoading(true);
    APIGetAnyStarrGMV({ selectType: gmvDataTime }).then(resp => {
      if (resp.data.result) {
        setGmvData(resp.data.result);
      }
    }).finally(() => {
      setCommissionDataLoading(false);
    });
  };

  useEffect(() => {
    getCommissionData();
  }, [commissionDataTime]);


  useEffect(() => {
    getGMVData();
  }, [gmvDataTime]);
  const {t} = useLanguage();
  const infoList1 = [
    {
      title: t('person_center.ecommerce_videos'),
      border: "1px solid #F0E0FF",
      bg:"linear-gradient(180deg, rgba(255, 255, 255, 0.07) 0%, rgba(175, 82, 222, 0.07) 100%)",
      icon: "/images/profile/anlay/ec-1.png",
      value: "llohellohellohellohello lohellohellohellohellohellohello",
      key: "ecVideoCount",
    },
    {
      title: t('person_center.ecommerce_lives'),
      border: "1px solid #FFE3C9",
      bg:"linear-gradient(180deg, rgba(255, 255, 255, 0.07) 0.03%, rgba(255, 170, 91, 0.07) 99.98%)",
      icon: "/images/profile/anlay/ec-2.png",
      value: "llohellohellohellohello lohellohellohellohellohellohello",
      key: "ecLiveCount",
    },
  ];
  const infoList2 = [
    {
      title: t('person_center.units_sold'),
      border: "1px solid #FFCFD6",
      bg:"linear-gradient(180deg, rgba(255, 255, 255, 0.07) 0.03%, rgba(255, 91, 113, 0.07) 99.98%)",
      icon: "/images/profile/anlay/ec-3.png",
      value: "-",
      pop: "Units are indexed to SKU. Note that if you has not given permission for TikTok precise data sharing, this property will not be present.",
      key: "unitsSold",
    },
    {
      title: t('person_center.avg_commission_rate'),
      border: "1px solid #D9E5FF",
      bg:"linear-gradient(180deg, rgba(255, 255, 255, 0.07) 0.03%, rgba(91, 143, 255, 0.07) 99.98%)",
      icon: "/images/profile/anlay/ec-4.png",
      value: "$1000",
      pop: "Note that if you has not given permission for TikTok precise data sharing, this property will not be present.",
      key: "avgCommissionRate",
    },
    {
      title: t('person_center.brand_collab_count'),
      border: "1px solid #DAF0EB",
      bg:"linear-gradient(180deg, rgba(255, 255, 255, 0.07) 0.03%, rgba(161, 214, 143, 0.07) 99.98%)",
      icon: "/images/profile/anlay/ec-5.png",
      value: "$1000",
      key: "brandCollaborationCount",
    },
  ];
  const infoList3 = [
    {
      title: t('person_center.avg_ec_live_view_count'),
      icon: avgLiveViewIcon,
      value: "$1000",
      key: "avgEcLiveViewCount",
    },
    {
      title: t('person_center.avg_ec_live_like_count'),
      icon: avgEcLiveLikeIcon,
      value: "$1000",
      key: "avgEcLiveLikeCount",
    },
    {
      title: t('person_center.avg_ec_live_comment_count'),
      icon: avgEcCommentIcon,
      value: "$1000",
      key: "avgEcLiveCommentCount",
    },
    {
      title: t('person_center.avg_ec_live_share_count'),
      icon: ecLiveShareIcon,
      value: "$1000",
      key: "avgEcLiveShareCount",
    },
    {
      title: t('person_center.avg_ec_video_like_count'),
      icon: avgEcVLikeIcon,
      value: "$1000",
      key: "avgEcVideoLikeCount",
    },
    {
      title: t('person_center.avg_ec_video_comment_count'),
      icon: ecAvgVideoCommentIcon,
      value: "$1000",
      key: "avgEcVideoCommentCount",
    },
    {
      title: t('person_center.avg_ec_video_share_count'),
      icon: avgEcVideoShareIcon,
      value: "$1000",
      key: "avgEcVideoShareCount",
    },
  ];

  const getGMV = () => {
    APIGetUserGMV().then(resp => {
      if (resp.data.returnMap) {
        setResMap({
          ...resp.data.returnMap.userGMV,
        });
      }
    });
  };

  useEffect(() => {
    getGMV();
  }, []);


  return <div className={styles.anlay_wrap}>

    <div className={styles.anlay_top_wrap}>
      <AnalyTopItem onGaWeek={"earnings_comm_week"} onGaMonth={"earnings_comm_month"} downIcon={"/images/profile/anlay/down-icon-1.png"} color={"!text-[#AD56FF]"} border={"1px solid #FF7CB733"} width={"263px"} bg={"linear-gradient(270deg, rgba(255, 133, 194, 0.08) 0%, rgba(187, 157, 243, 0.08) 100%)"} loading={anyStarrCommissionDataLoading} pop={t('person_center.data_delay_tip')} icon={"/images/profile/anlay/icon-1.png"} number={anyStarrCommissionData?.anyStarrCommission ?? "-"} rate={anyStarrCommissionData?.commissionComparePre} title={t('person_center.anystarr_commissions')} timeSelect={commissionDataTime} onChangeTimeSelect={(v) => setCommissionDataTime(v)}></AnalyTopItem>
      <AnalyTopItem  width={"190px"} pop={t('person_center.more_than_tiktok_tip')} icon={"/images/profile/anlay/icon-2.png"} number={anyStarrCommissionData?.moreCommission ?? "-"} title={t('person_center.more_than_open_collab')}></AnalyTopItem>
      <AnalyTopItem onGaWeek={"earnings_gmv_week"} onGaMonth={"earnings_gmv_month"} downIcon={"/images/profile/anlay/down-icon-3.png"} color={"!text-[#49B298]"} border={"1px solid #CEF2E2"} width={"263px"} bg={"linear-gradient(360deg, rgba(156, 238, 255, 0.11) 0%, rgba(157, 255, 196, 0.11) 100%)"} loading={commissionDataLoading} pop={t('person_center.data_delay_tip')} icon={"/images/profile/anlay/icon-3.png"} number={gmvData?.anyStarrGMV ?? "-"} rate={gmvData?.gmvComparePre} title={t('person_center.anystarr_gmv')} timeSelect={gmvDataTime} onChangeTimeSelect={(v) => setGmvDataTime(v)}></AnalyTopItem>
      <AnalyTopItem width={"190px"} pop={t('person_center.all_tiktok_gmv_tip')} icon={"/images/profile/anlay/icon-4.png"} number={anyStarrCommissionData?.tiktokGMV ?? "-"} title={t('person_center.full_platform_gmv')}></AnalyTopItem>
    </div>

    <SizeBox h={16}></SizeBox>

    <Spin spinning={anyStarrCommissionDataLoading} indicator={<CommonLoading></CommonLoading>}>
      <div className={"flex w-full min-h-[300px]"}>
        <CategoryDataDis title={t('person_center.category_gmv_distribution')} extData={resMap?.categoryIds ?? ""} data={anyStarrCommissionData?.category_gmv_distribution}></CategoryDataDis>
        <SizeBox w={16}></SizeBox>
        <CategoryDataDis title={t('person_center.content_gmv_distribution')} data={anyStarrCommissionData?.content_gmv_distribution}></CategoryDataDis>
      </div>
    </Spin>

    <div className={"mt-5"}>

      <div className={styles.section_title}>{t('person_center.ecommerce_data')}</div>

      <div className={"flex items-center justify-between"}>
        {
          infoList1.map(item => {
            return <ECommerceDataItem bg={item.bg} icon={item.icon} border={item.border} title={item.title} value={resMap[item.key] ?? "--"}></ECommerceDataItem>;
            // return <DataItem dataKey={item.key} resMap={resMap} icon={item.icon} value={item.value} title={item.title} pop={item?.pop}></DataItem>;
          })
        }
        {
          infoList2.map(item => {
            return <ECommerceDataItem bg={item.bg} icon={item.icon} border={item.border} title={item.title} value={resMap[item.key] ?? "--"}></ECommerceDataItem>;
            // return <DataItem dataKey={item.key} resMap={resMap} icon={item.icon} value={item.value} title={item.title} pop={item?.pop}></DataItem>;
          })
        }
      </div>
      <div className={"mt-[24px]"}></div>
      <div className={styles.section_title}>{t('person_center.content_data')}</div>
      <div className={"flex gap-[15px] flex-wrap"}>
        {
          infoList3.map(item => {
            return  <ContentDataItem  value={resMap[item.key] ?? "-"} title={item.title}></ContentDataItem>;
            // return <DataItem dataKey={item.key} resMap={resMap} icon={item.icon} value={item.value} title={item.title} pop={item?.pop}>
            //
            // </DataItem>;
          })
        }
      </div>
      {/* <CommonNormalBtn onClick={() => setShowCancelAuthModal(true)} className={"!w-[200px] mt-[20px]"}>Cancel Authorization</CommonNormalBtn>*/}

      <CancelAuthModal show={showCancelAuthModal} onCancel={() => setShowCancelAuthModal(false)}></CancelAuthModal>

    </div>

  </div>;
};


const TimeDropdown = ({ currentItem, setCurrentItem, color, downIcon }) => {
  const [open, setOpen] = useState();
  const {t} = useLanguage();
  const handleOpenChange = () => {

  };

  const render = () => {
    if (Number(currentItem) === 1) return t('person_center.week');
    if (Number(currentItem) === 2) return t('person_center.month');
    return "Week key";
  };


  const renderMenuItems = () => {
    return [
      {
        key: 1,
        label: <span className={`${currentItem === 1 && "font-bold"} text-[14px]`}>{t('person_center.week')}</span>,
        icon: null,
      },
      {
        key: 2,
        label: <span className={`${currentItem === 2 && "font-bold"} text-[14px]`}>{t('person_center.month')}</span>,
        icon: null,
      },
    ];
  };

  return <Dropdown
    menu={{
      items: renderMenuItems(),
      onClick: (v) => {
        setCurrentItem(v.key);
        console.log(v, "setCurrentItem");
      }
    }}
    trigger={["click"]}
    onOpenChange={handleOpenChange}
    open={open}
    key={"Select_Dropdown"}
  >
    <div key={"Select_Dropdown_Wrap"}>
      <div key={"Select_Dropdown_Wrap_Child"} className={`px-4 min-w-[93px] ${color} text-[14px] font-400 h-[23px] flex items-center rounded-full justify-center bg-[#FFFFFF] cursor-pointer`}>
        {render()}
        <img className={"w-[9px] h-[6px] ml-[7px]"} src={ downIcon ?? primary_down_icon} />
      </div>
    </div>
  </Dropdown>;
};



const AnalyTopItem = ({ onGaWeek, onGaMonth, width, bg, color, downIcon,  border, icon, title, number, rate, pop, timeSelect, onChangeTimeSelect, loading }) => {
  const {t} = useLanguage();
  const renderRate = () => {
    if (rate && Number(rate)) {
      let color = "F04A4A";
      let symbol = "";
      if (Number(rate) > 0) {
        color = "2BAD3A";
        symbol = "+";
      }
      return <div className={"border-t-[#BD90FF24] border-t"}>
        <div className={"text-[14px] mt-[4px] leading-[17px] text-[#A7A7A7]"}>
          <span className={`text-[#${color}] mr-[6px]`}>{symbol}{rate}%</span>
          {t('person_center.compared_to_last', { period: Number(timeSelect) === 1 ? t('person_center.week') : t('person_center.month') })}
        </div>
      </div>;
    }
    return null;
  };

  return <div style={{
    width: width,
    background: bg ?? "#fff",
    border: border ?? "1px solid #EDF0FE"
  }} className={styles.anlay_top_item}>
    <div className={styles.item_top}>
      <img src={icon} className={"w-[36px] h-[36px] shrink-0"} />
      {
        timeSelect && <>
          <div className={"flex-1"} />
          <TimeDropdown color={color} downIcon={downIcon} currentItem={timeSelect} setCurrentItem={(v)=>{
            onChangeTimeSelect(v);
            if (v.toString() === "1"){
              gaTracker.trackEvent(onGaWeek);
            }
            if (v.toString() === "2"){
              gaTracker.trackEvent(onGaMonth);
            }
          }} ></TimeDropdown>
        </>
      }
    </div>
    <div className={"mt-[5px] text-[14px] text-[#454D6C] font-400"}>
      {title}
      {
        pop && <CommonQuestionPop icon={"/images/profile/anlay/que-icon.png"} content={pop} className={"inline ml-[2px]"}></CommonQuestionPop>
      }
    </div>
    <div>
      <div className={"text-[22px] text-[#454D6C] mt-[5px] font-[700]"}>
        {
          loading ? <LoadingOutlined /> : number ?? "-"
        }
      </div>
      {
        renderRate()
      }
    </div>
  </div>;
};


const MyProfile = () => {
  const [freeSampleModal, setFreeSampleModal] = useState(false);
  const userInfo = useSelector(state => state.home.userInfo.userInfo);
  const [showCateModal, setShowCateModal] = useState(false);
  const {t, capBanner} = useLanguage();
  const renderCapStatus = useMemo(() => {
    if (userInfo?.obtain) {
      // return <GridDistortion
      //   imageSrc='/images/profile/profile-cap-ok.png'
      //   grid={10}
      //   mouse={0.1}
      //   strength={0.15}
      //   relaxation={0.9}
      //   className='custom-class !w-full !aspect-[4.1721] cursor-pointer'
      // />;
     return <div className={"relative"}>
       <img src={capBanner.capOK} className={"!w-full cursor-pointer"}></img>
       <img src={"/images/profile/text-cap.png"} className={"absolute bottom-[40px] !w-full cursor-pointer"}></img>
     </div>;
    }
    return <img onClick={() => {
           setFreeSampleModal(true);
          gaTracker.trackEvent("profile_unlock");
          }} src={capBanner.capLock} className={"!w-full cursor-pointer"}></img>;
  }, [userInfo]);

  return <div className={styles.right_card}>
   <div className={"w-full flex flex-row gap-[30px]"}>
     <div className={"w-[623px]"}>
       <div className={"w-full px-[30px] h-[128px] flex items-center gap-[22px] bg-[#F9FAFB] rounded-[16px] border-[#D5DDFF90] border"}>
         <AppImage className={"!w-[100px] !h-[100px] rounded-full"} src={userInfo?.avatarUrl}></AppImage>
         <div>
           <div className={"font-[700] text-[#0D132C] text-[20px]"}>
             {userInfo?.displayName}
           </div>
           <div className={"flex items-center gap-[12px] flex-wrap mt-[12px]"}>
             {userInfo?.userCategorys?.map(item=>{
               return  <div className={"text-[12px] rounded font-400 flex items-center bg-[#EDF0FE] h-[28px] px-[10px]"}>
                 {item}
               </div>;
             })}
             <div onClick={()=>{
               gaTracker.trackEvent("profile_none_category");
               setShowCateModal(true);
             }}>
               {
                 userInfo?.userCategorys?.length <= 0 ? <div className={"cursor-pointer text-[#fff] text-[14px] h-[28px] rounded-[6px] px-4 flex items-center justify-center bg-gradient-to-r from-[#CCD0DE] to-[#CCD0DE]"}>
                   {t('person_center.select_category')} <span className={"font-bold text-[20px] ml-1"}>+</span>
                 </div> : <AppImage onClick={()=>{
                   if ( userInfo?.userCategorys?.length >= 3){
                     gaTracker.trackEvent("profile_edit_category");
                   } else {
                     gaTracker.trackEvent("profile_add_category");
                   }
                 }} className={"cursor-pointer !w-[28px] !h-[28px]"} src={ userInfo?.userCategorys?.length >= 3 ? editTagIcon : addTagIcon}></AppImage>
               }
             </div>
           </div>
         </div>
       </div>
       <div className={"mt-8 text-[#222222] text-[16px] font-bold mb-[19px]"}>{t('person_center.basic_info')}</div>
       <div className={"flex items-center gap-[30px]"}>
         <ProfileItem title={t('person_center.follower_count')} num={formatKMBNumber(userInfo?.followerCount) ?? "-"} icon={"/images/profile/follower-count.svg"}></ProfileItem>
         <ProfileItem title={t('person_center.following_count')} num={formatKMBNumber(userInfo?.followingCount) ?? "-"} icon={"/images/profile/following-count.png"}></ProfileItem>
       </div>
       <div className={"flex items-center mt-[20px] gap-[30px]"}>
         <ProfileItem title={t('person_center.likes_count')} num={formatKMBNumber(userInfo?.likesCount) ?? "-"} icon={"/images/profile/like-count.svg"}></ProfileItem>
         <ProfileItem title={t('person_center.video_count')} num={formatKMBNumber(userInfo?.videoCount) ?? "-"} icon={"/images/profile/video-count.svg"}></ProfileItem>
       </div>
       <ProfileItem className={"!bg-[#F9FAFB] mt-[27px]"} subClassName={"flex flex-col-reverse"} title={t('person_center.bio_description')} num={userInfo?.bioDescription ?? "--"} icon={"/images/profile/bio-des.svg"}></ProfileItem>
     </div>
     <div className={"flex-1"}>
       {
         renderCapStatus
       }
     </div>
   </div>
    <CategorySelectModal noSkip={true} onSelected={userInfo?.userCategorys ?? []} visible={showCateModal} onCancel={()=>setShowCateModal(false)}></CategorySelectModal>
    {
      freeSampleModal && <UnLockHighestCommissionModal utmObtain={"sam_obtain"} onSuccess={() => {
        setFreeSampleModal(false);
      }} type={1} title={"-"} imgUrl={""} show={freeSampleModal} onCancel={() => setFreeSampleModal(false)}></UnLockHighestCommissionModal>
    }
  </div>;
};

const ProfileItem = ({ icon, title, num, className, subClassName }) => {
  return <div className={`bg-[#FFFFFF] w-full rounded-[16px] border-[#EDF0FE] flex items-center border px-[12px] py-[16px] ${className}`}>
    <AppImage className={"!w-[50px] !h-[50px]"} src={icon}></AppImage>
    <div className={`ml-[15px] ${subClassName}`}>
      <div className={"text-[#454D6C] text-[18px] font-500"}>{num}</div>
      <div className={"text-[#6E7281] text-[12px] font-400 mt-2"}>{title}</div>
    </div>
  </div>;
};


const ProfileInfoItem = ({ icon, title, value }) => {

  return <div className={"flex items-center h-[40px] justify-between w-full"}>
    <div className={"flex items-center"}>
      <img className={"w-6 h-6"} src={icon} />
      <div className={"text_a7 text-[14px] ml-3"}>{title}</div>
    </div>
    <div className={"text_222 text-[16px]"}>{value}</div>
  </div>;

};

const DataItem = ({ icon, title, value, pop, resMap, dataKey }) => {
  const {t} = useLanguage();
  const render = () => {
    if (dataKey === "categoryIds" && resMap && resMap[dataKey]) {
      if (resMap[dataKey] === "[]") {
        return "-";
      }
      return resMap[dataKey];
    }
    return resMap ? resMap[dataKey] ? resMap[dataKey] : "-" : "-";
  };
  return <div className={"w-full min-h-[52px] py-[14px] bg-[#F6F6F6] rounded-[8px] flex items-center justify-between px-[14px]"}>
    <div className={"flex items-center"}>
      <img src={icon} className={"w-[20px] h-[20px] mr-[16px]"} />
      <div className={"text_a7 text-[14px] mr-[9px]"}>{title}</div>
      {
        pop && <CommonQuestionPop content={pop}></CommonQuestionPop>
      }
    </div>
    <div className={"w-[50px]"}></div>
    <div className={"text_222 text-[16px] text-right"}>{render()}</div>
  </div>;
};

const TabItem = ({ id, current, label, onClick, icon, activeIcon }) => {
  const {t} = useLanguage();
  return <div onClick={() => onClick(id)} className={"w-full cursor-pointer"}>
    <div className={`flex transition-all bg-[#F9FAFB] px-[18px] gap-[10px] ease-in rounded-[4px] text-[14px] ${id === current ? "!bg-[#FFF1E4] !text-[#F0774A] !font-bold" : ""} items-center hover:bg-[#FFF1E4] text-[#454D6C] font-[400] h-[47px]`}>
      <Image className={"w-5 h-5"} preview={false} src={id === current ? activeIcon : icon}></Image>
      {label}
    </div>
  </div>;
};


const MyCollection = () => {
  const {t, isUS} = useLanguage();
  const [prodList, setProdList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [showNotAdded, setShowNotAdded] = useState(false);

  const [totalSize, setTotalSize] = useState(0);
  const [curPage, setCurPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);


  const [isAllSelect, setIsAllSelect] = useState(false);
  const [showCreate, setShowCreate] = useState(false);
  const [selectList, setSelectList] = useState(new Set([]));


  const getProdList = () => {
    let userInfo = localStorage.getItem("user");
    if (userInfo) {
      userInfo = JSON.parse(userInfo);
      setLoading(true);
      APIGetLikeProductList(JSON.stringify({
        page: curPage,
        pageSize: pageSize,
        isShowNotAdded: showNotAdded
      })).then(resp => {
        if (resp.data.result.records) {
          const newData = resp.data.result.records;
          newData.forEach(item => {
            item.collect = true;
          });
          setTotalSize(resp.data.result.total);
          setProdList(newData);
        }
      }).finally(() => {
        setLoading(false);
      });
    }
  };

  const onSelect = (ids) => {
    ids.forEach(item => {
      if (selectList.has(item)) {
        selectList.delete(item);
      } else {
        selectList.add(item);
      }
    });
    setSelectList(new Set([...selectList]));
  };

  const selectAll = () => {
    gaTracker.trackEvent("collection_selectall", true);
    if (isAllSelect) {
      setSelectList(new Set([]));
      setIsAllSelect(false);
    } else {
      setSelectList(new Set(prodList.map(item => item.productId)));
      setIsAllSelect(true);
    }
  };

  const toBatchAddTk = () => {
    gaTracker.trackEvent("collection_batch_add", true);
    if (selectList.size <= 0) {
      return message.info(t('person_center.please_select_products'));
    }
    setShowCreate(true);
  };


  useEffect(() => {
    getProdList();
    setIsAllSelect(false);
    setSelectList(new Set([]));
  }, [curPage, pageSize, showNotAdded]);

  const onShowSizeChange = (current, pageSize) => {
    setPageSize(pageSize);
  };

  return <div className={styles.right_card}>
    <div className={"flex items-center justify-between"}>
      <div className={"flex items-center"}>
        <div onClick={toBatchAddTk}
             className={"bg-linear cursor-pointer w-[258px] gap-[7px] rounded-[4px] !h-[35px] flex items-center justify-center text-[#FFFFFF] text-[16px]"}>
          <AppImage src={"/images/profile/batch-icon.svg"}></AppImage>
          {t('person_center.batch_add_to_showcase')}
        </div>
        <div onClick={selectAll} className={"flex items-center ml-[24px] cursor-pointer"}>
          <img className={"w-[24px] h-[24px]"} src={isAllSelect ? CheckedIcon : StatusIcon} />
          <div className={"ml-[5px] text-[14px] font-400"}>{t('person_center.select_all_on_page')}</div>
        </div>
      </div>
      {
        isUS && <CommonPopover content={t('person_center.only_view_not_added')}>
          <div onClick={() => {
            gaTracker.trackEvent("collection_toadd", true);
            setShowNotAdded(!showNotAdded);
          }} className={"flex items-center ml-[24px] cursor-pointer"}>
            <img className={"w-[24px] h-[24px]"} src={showNotAdded ? CheckedIcon : StatusIcon} />
            <div className={"ml-[12px] text-[14px] font-400"}>{t('person_center.exclude_added')}</div>
          </div>
        </CommonPopover>
      }
    </div>
    <Spin spinning={loading} indicator={<CommonLoading className={"!w-[30px] !h-[30px]"}></CommonLoading>}>
      <div className={"mt-[16px] flex flex-col min-h-[200px]"}>
        <div className={"grid grid-cols-4 gap-x-[16px]"}>
          {
            prodList && prodList.map(item => {
              // return <CollectionItem onSelect={onSelect} selectList={selectList} item={item}></CollectionItem>;
              return <ProductCard fromCollection={true} onSelect={onSelect} selected={selectList.has(item.productId)} key={item.productId} item={item}></ProductCard>;
            })
          }
        </div>

        {
          prodList.length === 0 && !loading && <CustomEmpty result={t('person_center.collection_empty')} routerAddress={"/"} />
        }

      </div>
    </Spin>


    {
      showCreate && <CreateLinkModal pidArr={Array.from(selectList)} show={showCreate} onCancel={() => setShowCreate(false)}></CreateLinkModal>
    }
  </div>;
};

const MyShowCase = ({ tabKey, setTabKey }) => {
  const {t} = useLanguage();
  const [pageToken, setPageToken] = useState();
  const [pageSize, setPageSize] = useState(20);
  const [curPage, setCurPage] = useState(0);
  const curPageRef = useRef(0);
  const [totalSize, setTotalSize] = useState(0);
  const [productList, setProductList] = useState([]);

  const [commissionList, setCommissionList] = useState([]);

  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);

  const getMyShowcase = (pageLoading = false) => {

    if (curPage < curPageRef.current) {
      setCurPage(curPage + 1);
      return;
    }

    if (pageLoading) {
      setPageLoading(pageLoading);
    }

    setLoading(true);
    APIGetMyShowCase({
      page_token: pageToken,
      page_size: pageSize,
    }).then(resp => {
      const res = resp.data.result;
      if (res.data?.products) {
        curPageRef.current += 1;
        setCurPage(curPageRef.current);
        setPageToken(res.data.next_page_token);
        setProductList([...productList, ...res.data.products]);
        setTotalSize(res.data.total_count);
      }

    }).finally(() => {
      setLoading(false);
      setPageLoading(false);
    });
  };

  const [comTotalSize, setComTotalSize] = useState(0);
  const [comCurPage, setComCurPage] = useState(1);
  const [comPageSize, setComPageSize] = useState(20);
  const [comLoading, setComLoading] = useState(false);


  const [isAllSelect, setIsAllSelect] = useState(false);
  const [showCreate, setShowCreate] = useState(false);
  const [isDealFinish, setIsDealFinish] = useState(false);
  const [selectList, setSelectList] = useState(new Set([]));

  const timer = useRef(null);


  const onSelect = (ids) => {
    ids.forEach(item => {
      if (selectList.has(item)) {
        selectList.delete(item);
      } else {
        selectList.add(item);
      }
    });
    setSelectList(new Set([...selectList]));
  };

  const selectAll = () => {
    gaTracker.trackEvent("commincrease_selectall", true);
    if (isAllSelect) {
      setSelectList(new Set([]));
      setIsAllSelect(false);
    } else {
      setSelectList(new Set(commissionList.map(item => item.productId)));
      setIsAllSelect(true);
    }
  };

  const toBatchAddTk = () => {
    gaTracker.trackEvent("commincrease_batch_add", true);
    if (selectList.size <= 0) {
      return message.info(t('person_center.please_select_products'));
    }
    setShowCreate(true);
  };


  const onShowSizeChange = (current, pageSize) => {
    setComPageSize(pageSize);
  };

  useEffect(() => {
    getMyShowcase(true);
  }, []);


  const getCommissonList = (needLoading = true) => {
    if (tabKey !== 2) return;
    if (loading) return;
    if (needLoading) setComLoading(true);
    APIGetCommissonList({
      page: comCurPage,
      pageSize: comPageSize
    }).then(resp => {
      const res = resp.data.result;
      setIsDealFinish(res?.isDealFinish);
      if (res?.isDealFinish === false) {
        startLoopPull();
      } else {
        clearTimer();
      }
      if (res?.list) {
        setCommissionList(res.list.records);
        setComTotalSize(res.list.total);
      }
    }).finally(() => {
      setComLoading(false);
    });
  };

  useEffect(() => {
    getCommissonList();
  }, [comCurPage, comPageSize, tabKey]);

  const startLoopPull = () => {
    if (timer.current) return;
    timer.current = setInterval(() => {
      getCommissonList(false);
    }, 5000);
  };

  const clearTimer = () => {
    if (timer.current) {
      clearInterval(timer.current);
    }
  };

  useEffect(() => {
    return () => {
      clearTimer();
    };
  }, []);


  const items = productList.slice((curPage - 1) * pageSize, curPage * pageSize).map(item => {
    return <ProductItem item={item}></ProductItem>;
  });

  const breakpointColumnsObj = {
    default: 4, // 默认列数
    1920: 4,  // 屏幕宽度 >= 1440px 时为 5 列
    1600: 4, // 屏幕宽度 >= 1440px 时为 4 列
    1200: 3, // 屏幕宽度 >= 1100px 时为 3 列
    650: 2, // 屏幕宽度 < 650px 时为 2 列
  };

  const renderContent = () => {
    if (tabKey === 1) {
      return <div>
        <div className={"flex mt-[16px] items-center"}>
          <img className={"w-[20px] h-[20px]"} src={ShowcaseIcon} />
          <div className={"ml-[12px] text_8f text-[14px]"}>{t('person_center.showcase_product_count')}: <span className={"text_FF6 text-[20px] font-bold"}>{totalSize}</span></div>
        </div>

        <Spin spinning={pageLoading} indicator={<CommonLoading></CommonLoading>}>
          <div className={"mt-5"}></div>
          <Masonry
            breakpointCols={breakpointColumnsObj} // 响应式列数配置
            className={"my_masonry_grid"} // 容器类名
            columnClassName={"my_masonry_grid_column"} // 列的类名
          >
            {
              items
            }
          </Masonry>
        </Spin>

        {
          productList.length === 0 && !loading && <div className={"flex w-full justify-center items-center"}>
            <CustomEmpty result={t('person_center.showcase_empty')} routerAddress={"/"} />
          </div>
        }


        {
          <div className={"w-1/2 flex items-center mt-[30px] gap-[20px] ml-auto"}>
            {
              curPage > 1 ? <CommonNormalBtn className={"!w-[80px] ml-auto"} onClick={() => {
                setCurPage(curPage - 1);
              }}>{t('person_center.back')}</CommonNormalBtn> : <div className={"!w-[80px] ml-auto"} />
            }

            {
              (productList.length < totalSize || curPage < curPageRef.current) && <CommonPrimaryBtn className={"!w-[80px]"} onClick={() => getMyShowcase()} loading={loading}>{t('person_center.next')}</CommonPrimaryBtn>
            }
          </div>
        }

        {
          // productList.length > 0 && <div className={styles.list_pagination_wrap}>
          //   <Pagination
          //     size='small'
          //     className={styles.list_pagination}
          //     total={totalSize}
          //     pageSize={pageSize}
          //     showSizeChanger={true}
          //     current={curPage}
          //     onShowSizeChange={onShowSizeChange}
          //     onChange={(page) => {
          //       setCurPage(page);
          //     }}
          //     prevIcon={<img className={styles.pagination_icon} src={TablePre} alt='' />}
          //     nextIcon={<img className={styles.pagination_icon} src={TableNext} alt='' />}
          //   />
          // </div>
        }

      </div>;
    }

    return <div className={"mt-[16px]"}>
      <div className={"flex items-center justify-between"}>
        <div className={"flex items-center"}>
          <div onClick={toBatchAddTk}
               className={"bg-linear cursor-pointer w-[258px] gap-[7px] rounded-[4px] !h-[35px] flex items-center justify-center text-[#FFFFFF] text-[16px]"}>
            <AppImage src={"/images/profile/batch-icon.svg"}></AppImage>
            {t('person_center.batch_add_to_showcase')}
          </div>
          <div className={"flex items-center"}>
            <div onClick={selectAll} className={"flex items-center ml-[24px] cursor-pointer"}>
              <img className={"w-[24px] h-[24px]"} src={isAllSelect ? CheckedIcon : StatusIcon} />
              <div className={"ml-[5px] text-[14px] font-400"}>{t('person_center.select_all_on_page')}</div>
            </div>
            <CommonQuestionPop className={"ml-1"} content={t('person_center.commission_delay_tip')}></CommonQuestionPop>
          </div>
        </div>
        <div className={"flex items-center"}>
          <img className={"w-[20px] h-[20px]"} src={anay_icon} />
          <div className={"ml-[12px] text_8f text-[14px]"}>{t('person_center.product_count')}: <span className={"text_FF6 text-[20px] font-bold"}>{comTotalSize}</span></div>
        </div>
      </div>

      <Spin spinning={comLoading} indicator={<CommonLoading></CommonLoading>}>
        <div className={"mt-[16px] flex flex-col gap-[16px] min-h-[300px]"}>
          <div className={"grid grid-cols-4 gap-[16px]"}>
            {
              commissionList.map(item => {
                return <IncreaseItem item={item} onSelect={onSelect} selectList={selectList}></IncreaseItem>;
              })
            }
          </div>

          {
            (commissionList.length <= 0 && !loading && isDealFinish) && <div className={"flex w-full justify-center items-center"}>
              <CustomEmpty result={t('person_center.no_commission_increase')} routerAddress={"/"} />
            </div>
          }

        </div>
      </Spin>


      {
        !isDealFinish && !loading &&
        <div className={"mt-3 flex flex-col items-center"}>
          <AppImage src={CreateLinkLoadingGIF} className={"!w-[87px] !h-[58px]"} />
          <div className={"text-[14px] text-[#222] mt-5"}>{t('person_center.searching_higher_commission')}</div>
        </div>
      }

      {
        commissionList.length > 0 && <div className={styles.list_pagination_wrap}>
          <Pagination
            size='small'
            className={styles.list_pagination}
            total={comTotalSize}
            pageSize={comPageSize}
            showSizeChanger={true}
            current={comCurPage}
            onShowSizeChange={onShowSizeChange}
            onChange={(page) => {
              setComCurPage(page);
            }}
            prevIcon={<img className={styles.pagination_icon} src={TablePre} alt='' />}
            nextIcon={<img className={styles.pagination_icon} src={TableNext} alt='' />}
          />
        </div>
      }

    </div>;
  };

  return <div className={styles.right_card}>
    <div className={"flex items-center h-[52px] border-b border-[#EDEDED]"}>
      <div onClick={() => {
        setTabKey(1);
      }} className={`${tabKey === 1 ? "font-bold !text-[#F0774A] border-b-[2px] border-[#F0774A]" : ""} cursor-pointer flex items-center h-full `}>{t('person_center.my_showcase')}</div>
      <div onClick={() => {
        gaTracker.trackEvent("comm_increase", true);
        setTabKey(2);
      }} className={`${tabKey === 2 ? "font-bold !text-[#F0774A] border-b-[2px] border-[#F0774A]" : ""} ml-[40px] cursor-pointer flex items-center h-full`}>{t('person_center.commission_increase')}</div>
    </div>
    {
      renderContent()
    }

    {
      showCreate && <CreateLinkModal pidArr={Array.from(selectList)} show={showCreate} onCancel={() => setShowCreate(false)}></CreateLinkModal>
    }

  </div>;
};

const IncreaseItem = ({ item, onSelect, selectList }) => {
  const {t} = useLanguage();
  const userInfo = useSelector(state => state.home.userInfo.userInfo);

  const [showCreate, setShowCreate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [productLink, setProductLink] = useState("");
  const [freeSampleModal, setFreeSampleModal] = useState(false);
  const [getFreeSampleModal, setGetFreeSampleModal] = useState(false);
  const [freeSampleType, setFreeSampleType] = useState(1);
  const toAddTk = (e) => {
    e.preventDefault();
    e.stopPropagation();
    gaTracker.trackEvent("commincrease_add_showcase", true);
    if (loading) return;
    setLoading(true);
    APIGetLinkByPid(item.productId).then(resp => {
      if (resp?.data.url) {
        const url = resp.data.url;
        setProductLink(url);
        setShowCreate(true);
      } else {
        message.info("Sorry, The product has been taken down!");
      }
    }).finally(() => {
      setLoading(false);
    });
  };


  const statusItem = () => {

    if (item.inventoryStatus === "IN_STOCK") {
      return <div className={"bg-[#EAF7EC] rounded-[20px] rounded-br-[0px] px-2 text-[#2BAD3A] text-[12px] h-[20px] flex items-center"}>{t('person_center.in_stock')}</div>;
    }
    return <div className={"bg-[#FEEDED] rounded-[20px] rounded-br-[0px] px-2  text-[#F04A4A] text-[12px] h-[20px] flex items-center"}>{t('person_center.sold_out')}</div>;
  };

  const renderEarnWarp = useMemo(() => {
    if (userInfo?.obtain) {
      return <div className={"flex items-center mt-3 justify-between"}>
        <div className={"w-[80px] h-[20px] rounded-[18px] bg-[#F3F4F6] flex items-center justify-center"}>
          <div className={"text-sm font-700 text-color2"}>{`${item.finishRate}%`}</div>
        </div>
        <Image preview={false} className={"w-4"} src={"/images/home-card-right-icon.svg"} alt={""} width={11} height={8}></Image>
        <div className={"w-[80px] h-[20px] rounded-[18px] bg-[#F3F4F6] flex items-center justify-center"}>
          <div className={"text-sm font-700 text-color2 font-bold"}>{`${item.capRate ?? "-"}%`}</div>
          <Image preview={false} width={12} height={12} className={"w-4 h-3 ml-1"} src={"/images/anystarr-commission.svg"} alt={""}></Image>
        </div>
      </div>;
    }
    return <div className={"flex items-center mt-3 justify-between"}>
      <div className={"w-[80px] h-[20px] rounded-[18px] bg-[#F3F4F6] flex items-center justify-center"}>
        <div className={"text-sm font-700 text-color2"}>{`${item.finishRate}%`}</div>
        <AppImage width={12} height={12} className={"w-4 h-3 ml-1"} src={"/images/anystarr-commission.svg"} alt={""}></AppImage>
      </div>
      <AppImage className={"w-4"} src={"/images/home-card-right-icon.svg"} alt={""} width={11} height={8}></AppImage>
      <div onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        setFreeSampleType(1);
        setFreeSampleModal(true);
        gaTracker.trackEvent("commincrease_cap_comm");
      }} className={"w-[80px] h-[20px] rounded-[18px] bg-[#FFEEEE] flex items-center justify-center"}>
        <div className={"text-sm font-700 text-color2"}>{`${item.capRate ?? "-"}%`}</div>
        <AppImage width={12} height={12} className={"w-3 h-3 ml-1"} src={"/images/offical-commission.svg"} alt={""}></AppImage>
      </div>
    </div>;
  }, [userInfo]);

  return (
    <Link href={`/product/${item.productId}`} target={"_blank"}>
      <div onClick={()=>{
        gaTracker.trackEvent("commincrease_product_card");
      }} key={item.id} className={"box-shadow-4C relative cursor-pointer border-[#EDF0FE] border hover:border-primary rounded-[8px] overflow-hidden"}>
        <div className={"absolute top-3 left-3 z-10"} onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          onSelect([item.productId]);
        }}>
          {
            selectList.has(item.productId) ? <AppImage src={"/images/product/checked-icon.svg"}></AppImage> :
              <AppImage src={"/images/product/no-check-icon.svg"}></AppImage>
          }
        </div>
        <div className={"!h-[230px] w-full relative"}>
          <img src={getProductImage(item)} className={"!w-full !h-[230px] object-cover"}></img>
          <div className={"absolute top-3 right-3"}>
            {
              statusItem()
            }
          </div>
          <div className={"bg-[#0D132CE5] absolute !font-[300] bottom-0 w-full px-[10px] py-[4px] text-[#B3B6C1] text-[14px]"}>
            <div className={"line-clamp-1"}>
              {item.title}
            </div>
          </div>
        </div>
        <div className={"px-[9px] py-[9px]"}>
          <div className={"text-[#A7A7A7] text-[14px]"}>
            {t('person_center.current_commission')}: <span className={"text-[16px] text-[#6E7281]"}>{item.currentRate}%</span>
          </div>
          <div className={"text-[#A7A7A7] text-[14px]"}>
            {t('person_center.anystarr_commission')}:
          </div>
          {
            renderEarnWarp
          }
          <div className={"flex items-center mt-2 justify-between"}>
            <div className={"w-[85px] text-center text-[12px] text-[#B3B6C1]"}>{t('person_center.earnings')}</div>
            <div className={"w-[85px] text-center text-[12px] text-[#B3B6C1]"}>{t('person_center.max_earnings')}</div>
          </div>
          <div className={"mt-3 flex items-center justify-between gap-4"}>
            <div onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              setGetFreeSampleModal(true);
              gaTracker.trackEvent("commincrease_sample");
            }} className={"h-[28px] bg-[#FDEFE9] flex items-center justify-center w-full rounded-[6px]"}>
              <AppImage width={16} height={16} className={"w-4 h-4 mr-1"} src={"/images/free-sample.svg"} alt={""}></AppImage>
              <div className={"text-primary text-sm"}>Sample</div>
            </div>
            <div onClick={toAddTk} className={"h-[28px] hover:opacity-80 trans-all text-white flex items-center bg-linear justify-center w-full rounded-[6px]"}>
              {loading ? <LoadingOutlined /> : <AppImage width={16} height={16} className={"w-4 h-4 mr-1"} src={"/images/add-showcase.svg"} alt={""}></AppImage>}
              <div className={"text-white text-sm"}>Add</div>
            </div>
          </div>
        </div>
        {
          showCreate && <AddShowCaseStepModal productIds={item.productId} visible={showCreate} link={productLink} onCancel={() => setShowCreate(false)} />
        }
        {
          freeSampleModal && <UnLockHighestCommissionModal utmObtain={"highest_comm_obtain"} onSuccess={() => {
            setFreeSampleModal(false);
          }} type={freeSampleType} title={item.title} imgUrl={getProductImage(item)} show={freeSampleModal} onCancel={() => setFreeSampleModal(false)}></UnLockHighestCommissionModal>
        }
        {
          getFreeSampleModal && <GetFreeSampleModal productItem={{
            alyImage: getProductImage(item),
            title: item.title,
            needApplyLink: true,
            ...item
          }} title={item.title} imgUrl={getProductImage(item)} show={getFreeSampleModal} onCancel={() => setGetFreeSampleModal(false)}></GetFreeSampleModal>
        }
      </div>
    </Link>
  );
};


const ProductItem = ({ item }) => {
  const {t} = useLanguage();
  const userInfo = useSelector(state => state.home.userInfo.userInfo);
  const router = useRouter();
  const [freeSampleModal, setFreeSampleModal] = useState(false);
  const [getFreeSampleModal, setGetFreeSampleModal] = useState(false);
  const [freeSampleType, setFreeSampleType] = useState(1);
  const statusItem = () => {
    if (item.status.inventory_status === "IN_STOCK") {
      return <div className={"bg-[#EAF7EC] rounded-[20px] rounded-br-[0px] px-2 text-[#2BAD3A] text-[12px] h-[20px] flex items-center"}>{t('person_center.in_stock')}</div>;
    }
    return <div className={"bg-[#FEEDED] rounded-[20px] rounded-br-[0px] px-2 text-[#F04A4A] text-[12px] h-[20px] flex items-center"}>{t('person_center.sold_out')}</div>;
  };

  const rate = () => {
    return <div className={"text_FF6 text-[20px] font-bold"}>
      {item.commission?.rate / 100}%
    </div>;
  };

  const getPrice = (max, min) => {
    if (!max || !min){
      return `$${(max || min) ?? "--"}`;
    }
    if (max !== min) {
      return `$${min} ~ $${max}`;
    }
    return `$${max}`;
  };

  const getImage = () => {
    if (item.main_images && item.main_images.length >= 1) {
      return item.main_images[0].url;
    }
    return "";
  };

  const getBtn = () => {
    if (item.isPlatformProduct) {
      return <div onClick={() => {
        gaTracker.trackEvent("showcase_view");
        router.push(`/product/${item.id}`);
      }} className={"bg-[#FDEFE9] h-[30px] w-full mt-[15px] rounded-[4px] cursor-pointer flex items-center justify-center"}>
        <AppImage src={"/images/profile/link-icon.svg"}></AppImage>
        <div className={"text-[#F19B55] text-[14px]"}>{t('person_center.view')}</div>
      </div>;
    }
    return   <div onClick={() => {
      gaTracker.trackEvent("showcase_similar");
      router.push(`/?s=${encodeURIComponent(item.title)}&t=${2}&state=${Math.floor(Math.random() * 10)}&utm=person`);
    }} className={"bg-[#F4F6FE] h-[30px] cursor-pointer w-full mt-[15px] rounded-[4px] flex items-center justify-center"}>
      <AppImage src={"/images/profile/similar-icon.svg"}></AppImage>
      <div className={"text-[#6E7281] text-[14px] cursor-pointer"}>{t('person_center.similar')}</div>
    </div>;
  };

  const renderEarnWarp = useMemo(() => {
    if (!item.product){
      return null;
    }
    if (!userInfo?.obtain) {
      return <div className={"flex items-center mt-3 justify-between"}>
        <div className={"w-[80px] h-[20px] rounded-[18px] bg-[#F3F4F6] flex items-center justify-center"}>
          <div className={"text-sm font-700 text-color2"}>{`${item.product.finishRate}%`}</div>
          <AppImage width={12} height={12} className={"w-4 h-3 ml-1"} src={"/images/anystarr-commission.svg"} alt={""}></AppImage>
        </div>
        <AppImage className={"w-4"} src={"/images/home-card-right-icon.svg"} alt={""} width={11} height={8}></AppImage>
        <div onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setFreeSampleType(1);
          setFreeSampleModal(true);
        }} className={"w-[80px] h-[20px] rounded-[18px] bg-[#FFEEEE] flex items-center justify-center"}>
          <div className={"text-sm font-700 text-color2"}>{`${item.product.capRate ?? "-"}%`}</div>
          <AppImage width={12} height={12} className={"w-3 h-3 ml-1"} src={"/images/offical-commission.svg"} alt={""}></AppImage>
        </div>
      </div>;
    }
    return <div className={"flex items-center mt-3 justify-between"}>
      <div className={"w-[80px] h-[20px] rounded-[18px] bg-[#F3F4F6] flex items-center justify-center"}>
        <div className={"text-sm font-700 text-color2"}>{`${item.product.finishRate}%`}</div>
      </div>
      <Image className={"w-4"} src={"/images/home-card-right-icon.svg"} alt={""} width={11} height={8}></Image>
      <div className={"w-[80px] h-[20px] rounded-[18px] bg-[#F3F4F6] flex items-center justify-center"}>
        <div className={"text-sm font-700 text-color2 font-bold"}>{`${item.product.capRate ?? "-"}%`}</div>
        <Image width={12} height={12} className={"w-4 h-3 ml-1"} src={"/images/anystarr-commission.svg"} alt={""}></Image>
      </div>
    </div>;
  }, [userInfo?.obtain]);

  const getPaltmformWarp = () =>{
    if (item.isPlatformProduct) {
      return <>
        {
          renderEarnWarp
        }
        <div className={"flex items-center mt-2 justify-between"}>
          <div className={"w-[85px] text-center text-[12px] text-[#B3B6C1]"}>{t('person_center.earnings')}</div>
          <div className={"w-[85px] text-center text-[12px] text-[#B3B6C1]"}>{t('person_center.max_earnings')}</div>
        </div>
        {
          freeSampleModal && <UnLockHighestCommissionModal utmObtain={"highest_comm_obtain"} onSuccess={() => {
            setFreeSampleModal(false);
          }} type={freeSampleType} title={item.title} imgUrl={getImage()} show={freeSampleModal} onCancel={() => setFreeSampleModal(false)}></UnLockHighestCommissionModal>
        }
        {
          getFreeSampleModal && <GetFreeSampleModal productItem={{
            alyImage: getImage(),
            title: item.title,
            needApplyLink: true,
            ...item
          }} title={item.title} imgUrl={getImage()} show={getFreeSampleModal} onCancel={() => setGetFreeSampleModal(false)}></GetFreeSampleModal>
        }
      </>;
    }
    return <div className={"flex-1 mt-auto"}></div>;
  };

  return <div key={item.id} className={"box-shadow-4C border-[#EDF0FE] border mb-[16px] cursor-pointer hover:border-primary rounded-[8px] overflow-hidden"}>
    <div className={"!h-[230px] w-full relative"}>
      <AppImage src={getImage()} className={"!w-full !h-[230px]"}></AppImage>
      <div className={"absolute top-3 right-3"}>
        {
          statusItem()
        }
      </div>
      <div className={"bg-[#0D132CE5] absolute !font-[300] bottom-0 w-full px-[10px] py-[4px] text-[#B3B6C1] text-[14px]"}>
        <div className={"line-clamp-1"}>
          {item.title}
        </div>
        <div className={"!mt-[5px]"}>
          {t('person_center.price')}:{getPrice(item.price?.platform_discount_price.maximum_amount, item.price?.platform_discount_price.minimum_amount)}
        </div>
      </div>
    </div>
    <div className={"px-[9px] py-[15px] flex flex-col justify-between"}>
      <div className={"w-full"}>
        <div className={"flex items-center"}>
          <div className={"text-[#F0774A] font-bold text-[24px]"}>
            {rate()}
          </div>
          <div className={"text-[#A7A7A7] !ml-[10px] text-[14px] !font-[300]"}>
            {t('person_center.current_commission')}
          </div>
        </div>
        {
          getPaltmformWarp()
        }
      </div>
      {
        getBtn()
      }
    </div>
  </div>;
};

const ColItem = ({ title, value, valueClassName }) => {
  return <div className={`flex items-center flex-col ${styles.col_item}`}>
    <div className={`text_222 text-[14px] leading-[24px] ${valueClassName}`}>{value}</div>
    <div className={"text_a7 text-[12px] leading-[20px] mt-[7px]"}>{title}</div>
  </div >;
};


const CategoryDataDis = ({ data, title, extData }) => {
  const {t} = useLanguage();
  if (!data) return <div className={"flex w-full flex-col items-center justify-center"}>
    <AppImage src={"/images/chart-empty.png"} width={200} height={70} alt={"empty"} className={"w-[200px] h-[70px] object-contain"}></AppImage>
    <div className={"text-[#7A7A7A] text-sm mt-7"}>There's no data here yet. </div>
  </div>;

  const colorArray = [
    "#F08080", "#FF1493", "#D2691E", "#696969", "#FF8C00", "#F5DEB3",
    "#FFD700", "#5470C6", "#91CC75", "#FAC858", "#EE6666", "#73C0DE",
    "#FC8452", "#9A60B4", "#40E0D0", "#008080", "#1E90FF", "#00BFFF",
    "#00BFBF", "#708090", "#32CD32", "#7B68EE", "#DB7295", "#FFC0CB",
    "#EA7CCC", "#8A2BE2", "#DC143C", "#FFA07A"
  ];

  const collData = [
    {
      key: '1',
      label: <div className={"text_222 font-bold"}>{title}</div>,
      children: <div className={"flex mt-2 items-center justify-between"}>
        <div className={"text-[#222222B2] text-sm font_noto"}>{t('person_center.categories')}</div>
        <div className={"text_222 font-400 font_noto text-sm w-2/3 text-right"}>
          {
            extData?.split(",").map((item, index) => {
              if (index < 2) {
                return <p className={"mb-0"}>{item}</p>;
              }
              if (index === 2) {
                return <p className={"mb-0"}>{item}...</p>;
              }
              return null;
            })
          }
        </div>
      </div>
    },
  ];

  // 转换数据
  const legendData = data
    .filter(item => item.category_name || item.content_type)  // 过滤掉没有 category_name 的项
    .map(item => {
      const categoryName = item.category_name || item.content_type;
      const percentage = parseFloat((parseFloat(item.value) * 100).toFixed(2)); // 计算百分比
      return { name: categoryName, percentage }; // 返回分类名称和百分比
    }).sort((a, b) => {
      return b.percentage - a.percentage;
    });

  const pieData = data
    .filter(item => item.category_name || item.content_type)  // 过滤掉没有 category_name 的项
    .map((item, index) => ({
      value: parseFloat((parseFloat(item.value) * 100).toFixed(2)),  // 转换为百分比
      name: item.category_name || item.content_type,
    })).sort((a, b) => {
      return b.value - a.value;
    }).map((item, index) => {
      item.itemStyle = {
        color: colorArray[index % colorArray.length] // 根据数组中的颜色设置颜色，避免越界
      };
      return item;
    });

  const option = {
    tooltip: {
      show: true,
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c}%'
    },
    legend: {
      orient: 'vertical',
      right: '0',
      show: false,
      top: 'center',
      itemWidth: 10,
      itemHeight: 10,
      formatter: function (name) {
        const item = legendData.find(i => i.name === name);
        // 强制换行，限制文本长度
        const realName = item.name.replace(/(.{20})(?=.)/g, '$1\n');
        const formattedName = `${realName} (${item.percentage}%)`;
        return formattedName;  // 每20个字符换一行
      }
    },
    series: [
      {
        name: 'GMV Distribution',
        type: 'pie',
        itemStyle: {
          borderRadius: 5,
          borderColor: '#fff',
          borderWidth: 1
        },
        radius: ['45%', '90%'],
        center: ['50%', '50%'],
        data: pieData,       // 动态生成饼图数据
        label: {
          show: false,
          formatter: '{b}: {c}%'
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ]
  };

  const renderTitle = () => {

    if (extData) {
      return <Collapse
        expandIconPosition={"end"}
        defaultActiveKey={['0']} ghost items={collData} />;
    }

    return <div className={"text_222 mb-[10px] font-bold"}>{title}</div>;
  };

  return (
    <div className={styles.anlay_chart_wrap}>
      {renderTitle()}
      <div className={"flex items-center justify-between"}>
        <ReactECharts option={option} className={"w-[200px] h-[200px]"} />
        <SizeBox w={10}></SizeBox>
        <div className={"max-h-[240px] overflow-scroll"}>
          {
            legendData.map((item, index) => {
              return <div className={"flex items-start leading-[2]"}>
                <div className={"h-[24px] flex items-center shrink-0"}>
                  <div className={`shrink-0 w-[6px] h-[6px] rounded-full`} style={{
                    background: colorArray[index % colorArray.length]
                  }}></div>
                </div>
                <SizeBox w={10}></SizeBox>
                <div className={"text_222 text-[12px]"}>
                  {item.name} ({item.percentage}%)
                </div>
              </div>;
            })
          }

          {
            legendData.length <= 0 && <div className={"text_a7 text-center mr-5"}>
              {t('person_center.no_data_yet')}
            </div>
          }

        </div>
      </div>
    </div>
  );
};

const ECommerceDataItem = ({title, value, icon, bg, border}) =>{
  const {t} = useLanguage();
  return <div
    style={{
      background: bg,
      border: border,
    }}
    className={"w-[177px] h-[141px] top-[722px] left-[397px] rounded-[12px] border-[1px] py-[15px] px-[20px]"}>
    <div className={"flex justify-end"}>
      <AppImage src={icon} className={"!w-[38px] !h-[38px]"}/>
    </div>
    <div className={"text-[#454D6C] text-[22px] font-[700] mt-[6px]"}>{value}</div>
    <div className={"text-[#A7A7A7] text-[14px] font-400 mt-[15px]"}>{title}</div>
  </div>;
};


const ContentDataItem = ({title, value}) =>{
  const {t} = useLanguage();
  return <div className={"w-[225px] h-[115px] py-[25px] px-[15px] rounded-[12px] border-[1px]"}>
    <div className={"text-[#454D6C] text-[22px] font-[700]"}>{value}</div>
    <div className={"text-[#A7A7A7] text-[14px] mt-[15px]"}>{title}</div>
  </div>;
};

export default PersonCenter;
